import * as React from 'react'
import { silRequirementStatus } from '@axilon-apps/domains-ontology-ui-state'
import { Badge } from '../../components/ui/badge'

export function SilRequirementBadge({
  requiredSil,
  achievedSil,
  showUnavailable = false
}: {
  requiredSil?: string
  achievedSil?: string
  showUnavailable?: boolean
}): React.ReactElement | null {
  const status = silRequirementStatus(requiredSil, achievedSil)
  if (status === 'unavailable') {
    return showUnavailable ? <span className="text-ink-4">—</span> : null
  }
  return (
    <Badge variant={status === 'met' ? 'secondary' : 'destructive'}>
      {status === 'met' ? 'Meets requirement' : 'Below required'}
    </Badge>
  )
}
